'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tasks;

var _preact = require('preact');

var _reactRouterDom = require('react-router-dom');

var _taskForm = require('../../containers/taskForm.js');

var _taskForm2 = _interopRequireDefault(_taskForm);

var _taskList = require('../../containers/taskList.js');

var _taskList2 = _interopRequireDefault(_taskList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Tasks(props) {
  return (0, _preact.h)(
    'div',
    { 'class': 'column' },
    (0, _preact.h)(
      'div',
      { 'class': 'window' },
      (0, _preact.h)(
        'div',
        { 'class': 'heading' },
        (0, _preact.h)(
          'b',
          null,
          'create task'
        )
      ),
      (0, _preact.h)(_taskForm2.default, null)
    ),
    (0, _preact.h)(
      'div',
      { 'class': 'window' },
      (0, _preact.h)(
        'div',
        { 'class': 'heading' },
        (0, _preact.h)(
          'b',
          null,
          'recent tasks'
        )
      ),
      (0, _preact.h)(_taskList2.default, null)
    )
  );
}


//////////////////
// WEBPACK FOOTER
// ./client/components/Tasks/Tasks.jsx
// module id = 83
// module chunks = 0